import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.structures.phoneNumber',
    'resource:data.structures.emailAddress',
    'resource:data.structures.contactInfo',
    'resource:data.structures.contact',
    'resource:data.structures.address',
  ],
  description: 'Just a handful of simple, common structures',
  name: 'Common Structures',
} as const satisfies core.quiver.Package
